/* eslint-disable @typescript-eslint/no-unused-vars */
import { styled, SvgIcon } from "@mui/material";
import { ArrowRightIcon } from "utils/svgIcons";
import { Link as RouterLink } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ThemeButton from "../ThemeButton";
import { LOCAL_STORAGE_LOGIN_FROM, useGoogleAnalyticsContext } from "contexts";
import scopelyIcon from "assets/ico-scopely-v2.svg";
import { useScopelySignUp } from "hooks/useScopelySignUp";
import { useLinks } from "hooks/useLinks";

const _SectionButton = styled(ThemeButton)`
	background: linear-gradient(180deg, #4088b7 0%, #1c6595 100%);
	border: 1px solid #52a5dc;
	width: 194px;
	&:hover {
		background: linear-gradient(180deg, #36a1e8 0%, #2070a5 100%),
			linear-gradient(0deg, #4ab8ff, #4ab8ff);
	}
`;

const SectionButton = ({
	isExternal,
	href,
	title,
	text,
	analytics,
	playgamiAnalytics,
	openExternalSameTab = false
}: {
	isExternal: boolean;
	href: string;
	title: string;
	text: string;
	openExternalSameTab?: boolean;
	analytics: string;
	playgamiAnalytics: string;
}) => {
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const {
		startLogin,
		logout,
		location,
		initiateLogin,
		isScopelyIdentityReady
	} = useScopelySignUp();
	/* eslint-disable-next-line */
	const Button: any = _SectionButton;
	const links = useLinks();
	const isScopelySignupButton = title === links.sign_up_scopely?.title;

	return (
		<>
			{!isExternal ? (
				<Button
					to={href}
					component={RouterLink}
					onClick={() => {
						window.scrollTo(0, 0);
						reportEvent(analytics, { source: "home_page" });
						reportPlaygamiEvent("tp.web_frontend", {
							event_name: playgamiAnalytics.split("#")[0],
							event_type: playgamiAnalytics.split("#")[0],
							action: "click",
							source: playgamiAnalytics.split("#")[1]
						});
					}}
					sx={{
						lineHeight: "18px"
					}}
				>
					{text}
					<SvgIcon component={ArrowRightIcon} />
				</Button>
			) : (
				<Button
					disabled={isScopelySignupButton && !isScopelyIdentityReady}
					onClick={() => {
						if (isScopelySignupButton) {
							if (!isScopelyIdentityReady) {
								return;
							}

							//logout();
							localStorage.setItem(
								LOCAL_STORAGE_LOGIN_FROM,
								"signup_incentive"
							);
							reportEvent(analytics.split("#")[0], {
								source: analytics.split("#")[1],
								action: "click",
								popup_type: analytics.split("#")[2]
							});
							reportPlaygamiEvent("tp.web_frontend", {
								event_name: playgamiAnalytics.split("#")[0],
								event_type: playgamiAnalytics.split("#")[0],
								action: "click",
								source: playgamiAnalytics.split("#")[1],
								type: playgamiAnalytics.split("#")[2]
							});
							//startLogin(location.pathname);
							initiateLogin(location.pathname);
							return;
						}
						window.open(href, openExternalSameTab ? "_self" : "_blank");
						reportEvent(analytics, { source: "home_page" });
					}}
					sx={{
						minWidth: "194px",
						width: "auto",
						lineHeight: "18px"
					}}
				>
					{isScopelySignupButton && <img src={scopelyIcon}></img>}
					{text}
					<OpenInNewIcon />
				</Button>
			)}
		</>
	);
};

export default SectionButton;
